import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { Observable, of } from "rxjs";

@Injectable()
export class QSAuth implements CanActivate {
    constructor(private router: Router, private http: HttpClient) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.isAllowedAccess(route);
    }

    private isAllowedAccess(
        route: ActivatedRouteSnapshot
    ): Observable<boolean> {
        let returnVal = of(false);
        returnVal = Observable.create((observer) => {
            this.http
                .get(
                    "api/QSAuthorization/" +
                        route.data.qsSection +
                        "/" +
                        route.params.projectId +
                        "/" +
                        route.params.id +
                        "/" +
                        route.queryParams.securityToken,
                    { responseType: "text" }
                )
                .subscribe(
                    (data) => {
                        if (data != null) {
                            const allowed =
                                data.toLowerCase() == "edit"
                                    ? true
                                    : (route.data.mode == "view" ||
                                          route.data.mode == "review") &&
                                      data.toLowerCase() == "view"
                                    ? true
                                    : false;

                            observer.next(allowed);
                            observer.complete();

                            if (!allowed)
                                this.router.navigateByUrl(
                                    "/unauthorized?security=" +
                                        route.data.siteworkSection
                                );
                        } else {
                            observer.next(false);
                            observer.complete();
                            this.router.navigateByUrl(
                                "/unauthorized?security=" +
                                    route.data.siteworkSection
                            );
                        }
                    },
                    (err) => {
                        observer.next(false);
                        observer.complete();

                        this.router.navigateByUrl(
                            "/unauthorized?security=" +
                                route.data.siteworkSection
                        );
                    }
                );
        });

        return returnVal;
    }

    getData(route: ActivatedRouteSnapshot): any {
        const youngest = this.getYoungest(route);
        return youngest.data;
    }

    getYoungest(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
        if (route.firstChild) return this.getYoungest(route.firstChild);
        return route;
    }
}
